import ServiceAccordion from "../components/ServiceAccordion.jsx";
import { useAzureConfig } from '../../../../../context/Dashboard/azure/contextConfig.js';
import { useParams } from "react-router-dom";

export default function ServiceModuleAws() {
  const service_name = useParams().service;
  const { cAzureConfigAll : data } = useAzureConfig();
  const serviceData = data.services[service_name];
  
  return (
    <div className="container py-4">
      <div className="mb-4 fw-semibold text-dark text-capitalize">
        {service_name} Dashboard
      </div>

      <ServiceAccordion 
        findings={serviceData?.findings} 
        regions={serviceData?.regions}
      />
    </div>
  );
}
